import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { Box, Typography } from '@mui/material';
import { BsPlusCircle } from 'react-icons/bs';
import { Table } from 'components';
import { getColumnsPersonal } from './columns-personal';
import ApiServices from 'services';
import Utils from 'commons/utils';
import { ContainerHeader, BtnCreateContract } from './styles';
// import storage from 'storage';
import { CreateForm } from './create-form';
import { ModalFormDetail } from 'components';
import { debounce } from 'lodash';

const DEFAULT_FILTER = {
  pageNumber: 1,
  pageSize: 10,
};

export function QuotePrice() {
  const [contractList, setContractList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);

  const [searchQuotationDate, setSearchQuotationDate] = useState(null);
  const [searchCustomerResponseDate, setSearchCustomerResponseDate] = useState(null);

  const [searchStatus, setSearchStatus] = useState(-1);

  const [filter, setFilter] = useState(DEFAULT_FILTER);

  const initData = (query, status = searchStatus) => {
    setLoading(true);
    return ApiServices.getPagingClientQuotation(query ? query : filter, status)
      .then((res) => {
        if (res?.data) {
          if (totalRecords !== res?.data?.totalRecords) setTotalRecords(res?.data?.totalRecords);
          setContractList(res?.data?.data || []);
        }
      })
      .catch((err) => console.warn('get Client Trash:', err))
      .finally(() => setLoading(false));
  };

  const handleSearchColumn = (event) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };
      const { value, name } = event.target;
      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };
  const handleSearchColumnDate = (value, name) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };

      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };

  const timeoutGetData = useCallback(
    debounce((newFilter, newSearchStatus) => {
      initData(newFilter, newSearchStatus);
    }, 500),
    [],
  );
  useEffect(() => {
    timeoutGetData(filter, searchStatus);
  }, [filter, searchStatus]);

  const onCloseModal = () => {
    setSelected(null);
  };

  const reloadData = async () => {
    return await initData(filter, searchStatus);
  };

  const handleChangeSearchQuotationDate = (event) => {
    const date = event.target.value;
    setSearchQuotationDate(date);

    const dateSearch = date ? moment(date).format('YYYY-MM-DD') : null;
    handleSearchColumnDate(dateSearch, 'quotationDate');
  };

  const handleChangeSearchCustomerResponseDate = (event) => {
    const date = event.target.value;
    setSearchCustomerResponseDate(date);

    const dateSearch = date ? moment(date).format('YYYY-MM-DD') : null;
    handleSearchColumnDate(dateSearch, 'customerResponseDate');
  };

  const handleChangeSearchStatus = (event) => {
    let value = event.target.value;

    setSearchStatus(value);
  };

  const deleteItem = async (row) => {
    setLoading(true);
    try {
      const res = await ApiServices.deleteQuotePrice(row?.id);
      if (res) {
        window.UIMessage?.success('Xóa thành công');
        reloadData();
      }
    } catch (err) {
      window.UIMessage?.error('Xóa thất bại !!!');
      console.warn('delete contract', err);
    }
    setLoading(false);
  };

  const validateValue = (row) => {
    const dataSelect = row;
    dataSelect.quotationDate = Utils.checkIsDate(row.quotationDate)
      ? Utils.convertToDateFormat(row?.quotationDate)
      : null;
    dataSelect.customerResponseDate = Utils.checkIsDate(row.customerResponseDate)
      ? Utils.convertToDateFormat(row?.customerResponseDate)
      : null;

    return dataSelect;
  };

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <Typography variant="h6" component="h6" sx={{ m: '10px' }}>
          Báo giá
        </Typography>
      </ContainerHeader>
      {/* <ButtonExport
        variant="outlined"
        startIcon={<BsArrowDownCircle />}
        onClick={handleExportClient}
      >
        Tải excel
      </ButtonExport> */}
      <BtnCreateContract
        variant="contained"
        startIcon={<BsPlusCircle />}
        onClick={() => setSelected({ isNew: true })}
      >
        Thêm mới
      </BtnCreateContract>
    </>
  );

  const handleSelected = (row) => {
    const dataSelect = validateValue(row);
    setSelected(dataSelect);
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Table
          rows={contractList}
          headCells={getColumnsPersonal(
            handleSearchColumn,
            deleteItem,
            searchQuotationDate,
            handleChangeSearchQuotationDate,
            searchCustomerResponseDate,
            handleChangeSearchCustomerResponseDate,
            searchStatus,
            handleChangeSearchStatus,
          )}
          totalRecords={totalRecords}
          onPageChange={(paging) => {
            setFilter((prev) => ({ ...prev, ...paging }));
          }}
          onClickDetail={handleSelected}
          loading={loading}
          renderHeader={renderHeader}
        />

        <ModalFormDetail
          open={selected}
          onCloseModal={onCloseModal}
          title={selected?.isNew ? 'Thêm mới' : 'Cập nhật'}
          maxWidth="md"
        >
          <CreateForm reloadData={reloadData} onCloseModal={onCloseModal} selected={selected} />
        </ModalFormDetail>
      </Box>
    </>
  );
}
